<template>
  <v-container
    fluid
    class="pt-2"
    :class="{ 'px-2': $vuetify.breakpoint.width <= 1600, 'pl-0': $vuetify.breakpoint.width > 1600 }"
  >
    <v-layout>
      <v-flex xs6 sm3 class="user-details-container">
        <v-card class="pa-2">
          <v-list three-line dense class="transparent">
            <template v-for="user in SelectedAccount.users">
              <v-list-item
                :key="`list-${user.id}`"
                @click="selectUser(user)"
                :class="{ 'primary--text': isActiveUser(user.id) }"
              >
                <v-list-item-content>
                  <v-list-item-title v-if="user.name">{{ user.name.first }} {{ user.name.last }}</v-list-item-title>
                  <v-list-item-subtitle class="text--primary">{{ user.email }}</v-list-item-subtitle>
                  <v-list-item-subtitle
                    ><strong>Last login: </strong> {{ user.last_logged_in_at }}</v-list-item-subtitle
                  >
                </v-list-item-content>
              </v-list-item>
              <v-divider :key="`divider-${user.id}`"></v-divider>
            </template>
          </v-list>
        </v-card>
      </v-flex>
      <v-flex xs12 sm6>
        <v-card class="ml-2">
          <v-toolbar flat color="white" class="pl-3">
            <v-toolbar-title v-if="selectedUser.name"
              >{{ selectedUser.name.first }} {{ selectedUser.name.last }} - Permissions</v-toolbar-title
            >
          </v-toolbar>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs6>
                  <v-card-title class="pl-0">Platform views</v-card-title>
                  <v-form>
                    <v-layout v-for="platform in platforms" :key="platform.id" wrap>
                      <v-flex xs12>
                        <user-security-role :user="selectedUser" :business="platform"></user-security-role>
                      </v-flex>
                    </v-layout>
                  </v-form>
                </v-flex>
                <v-flex xs6>
                  <v-card-title class="pl-0">Business views</v-card-title>
                  <v-form>
                    <v-layout v-for="business in SelectedAccount.businesses" :key="business.id" wrap>
                      <v-flex xs12>
                        <user-business-role :user="selectedUser" :business="business"></user-business-role>
                      </v-flex>
                    </v-layout>
                  </v-form>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import _ from 'lodash';
import { mapActions, mapGetters } from 'vuex';
import UserBusinessRole from './Widgets/UserBusinessRole';
import UserSecurityRole from './Widgets/UserSecurityRole';

export default {
  components: { UserBusinessRole, UserSecurityRole },
  name: 'account-users',
  data: () => ({
    selectedUser: {
      name: {}
    },
    ownerRole: {
      type: {
        name: 'Owner'
      }
    }
  }),
  computed: {
    ...mapGetters(['SelectedAccount', 'UILeftDrawer', 'PlatformUser', 'UserHasRole']),
    screenIsWideEnough: function() {
      return this.$vuetify.breakpoint.width > 1600;
    },
    platforms() {
      let availableTypes = _.uniqBy(this.SelectedAccount.businesses, business => business.type.name);
      if (!_.isUndefined(_.find(availableTypes, platform => platform.type.name === 'property_broker'))) {
        availableTypes.push(this.ownerRole);
      }
      return availableTypes;
    }
  },
  methods: {
    ...mapActions(['updateAccountUser', 'sendWelcomeMessage', 'selectAccount']),
    selectUser: function(user) {
      this.selectedUser = user;
    },
    isActiveUser(id) {
      return id === this.selectedUser.id;
    }
  },
  mounted() {
    this.selectedUser = this.SelectedAccount.users[0];
  },
  watch: {
    SelectedAccount: function() {
      this.selectedUser = _.isUndefined(this.SelectedAccount.users[0])
        ? { full_name: null }
        : this.SelectedAccount.users[0];
    }
  }
};
</script>

<style lang="scss" scoped>
.user-details-container {
  height: calc(100vh - 130px);
  max-height: calc(100vh - 130px);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
</style>
